import DefaultPage from "./default";
import { createWidget } from "@typeform/embed";

class SurveyPage extends DefaultPage {
  static instance;

  static init() {
    if (!SurveyPage.instance) {
      SurveyPage.instance = new SurveyPage();
    }
    return SurveyPage.instance;
  }

  constructor() {
    super();

    this._container = document.querySelector("#typeform-wrapper");
    this._formId = this._container.dataset["formId"];
    this._hiddenFields = undefined;

    try {
      this._hiddenFields =
        JSON.parse(this._container.dataset["hiddenFields"]) || undefined;
    } catch (e) {
      console.error("error: failed to parse hidden fields: ", e);
    }

    this._startup();
  }

  _startup() {
    const typeform = createWidget(this._formId, {
      container: this._container,
      source: window.location.hostname,
      height: "100%",
      hidden: this._hiddenFields,
    });

    this.setup_modal()
  }

  setup_modal() {
    // const modalBtn = document.querySelector(".btn-modal");
    const modal = document.querySelector(".modal-overlay");
    const modalClose = document.querySelector(".modal__icon");

    if (modal.dataset["openModalAutomatically"] === "true") {
      document.body.classList.add("modal-is-open");
    }
    // modalBtn.addEventListener("click", () => {
    // });

    modalClose.addEventListener("click", () => {
      document.body.classList.remove("modal-is-open");
    });

    document.body.addEventListener("keydown", (e) => {
      if (e.keyCode === 27) {
        document.body.classList.remove("modal-is-open");
      }
    });

    // close modal when click outside
    modal.addEventListener("click", (e) => {
      if (!e.target.closest(".modal")) {
        document.body.classList.remove("modal-is-open");
      }
    });


    document.querySelector("#modal__form").addEventListener("submit", async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const formData = new FormData(e.target);
      try {
        const res = await fetch("/api/v1/webhooks/promotion-subscription", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            email: formData.get("email"),
            backerUserExternalId: formData.get("backerUserExternalId"),
            projectId: formData.get("projectId"),
          })
        }).then(async r => await r.json());

        if (!res.success) {
          throw new Error(res.error.message);
        }

        document.body.classList.remove("modal-is-open");
      } catch (e) {
        alert(e.message)
      }

    });

  }
}

export default SurveyPage;
